import React from 'react';
import Select from '../../../components/ui/Select';

const SortControls = ({ sortBy, onSortChange, viewMode, onViewModeChange }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'salary-high', label: 'Salary: High to Low' },
    { value: 'salary-low', label: 'Salary: Low to High' },
    { value: 'deadline', label: 'Deadline: Earliest First' },
    { value: 'posted', label: 'Recently Posted' }
  ];

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 md:gap-4">
      <div className="w-full sm:w-64">
        <Select
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
          className="mb-0"
        />
      </div>
      <div className="hidden md:flex items-center gap-2">
        <button
          onClick={() => onViewModeChange('grid')}
          className={`p-2 rounded-md transition-smooth ${
            viewMode === 'grid' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
          aria-label="Grid view"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="7" height="7" rx="1" fill="currentColor" />
            <rect x="11" y="2" width="7" height="7" rx="1" fill="currentColor" />
            <rect x="2" y="11" width="7" height="7" rx="1" fill="currentColor" />
            <rect x="11" y="11" width="7" height="7" rx="1" fill="currentColor" />
          </svg>
        </button>
        <button
          onClick={() => onViewModeChange('list')}
          className={`p-2 rounded-md transition-smooth ${
            viewMode === 'list' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
          aria-label="List view"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="3" width="16" height="3" rx="1" fill="currentColor" />
            <rect x="2" y="8.5" width="16" height="3" rx="1" fill="currentColor" />
            <rect x="2" y="14" width="16" height="3" rx="1" fill="currentColor" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SortControls;